import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import DropdownMenuNavigations from '../dropdownmenunavigations';

const Aside = () => {
  const inactiveStr = classNames(
    'flex items-center justify-start bg-transparent p-2.5 text-base font-medium rounded-lg no-underline hover:bg-[hsl(221,13%,30%)] group',
  );
  const activeStr = classNames(
    'flex items-center justify-start bg-[hsl(221,13%,45%)] p-2.5 text-base font-medium rounded-lg no-underline group',
  );
  return (
    <ul className="space-y-4">
      {DropdownMenuNavigations.map(({ link, icon, label }, index) => {
        return (
          <li key={index}>
            <NavLink
              to={link}
              end
              className={({ isActive }) => (isActive ? activeStr : inactiveStr)}
            >
              {icon}
              <span className="ml-3 text-white">{label}</span>
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
};

export default Aside;
